/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    CANCEL: 'Annuler',
    CONFIRM: 'Confirmer',
    NEW_INVOICE: 'Nouvelle facture'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Erreur lors de la soumission de l\'accumulation',
    CANCEL_ACCUMULATION: 'Erreur lors de l\'annulation de l\'accumulation',
    CANCEL_INVOICE: 'Erreur lors de l\'annulation de la facture',
    COUPON_CANCELED: 'Erreur lors de l\'annulation du coupon',
    COUPON_GENERATED: 'Erreur lors de la création du coupon',
    ERROR: 'Erreur',
    INVOICE_SUBMITTED: 'Erreur lors de la soumission de la facture'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Rémunération accum.',
    ATTACHMENT: 'Pièce jointe',
    CHALLENGE: 'Challenge',
    COUPON: 'Coupon',
    COUPON_CODE: 'Code du coupon',
    DECISION: 'Décision',
    MONTH: 'Mois',
    OBSERVATIONS: 'Observations',
    REMUNERATION: 'Rémunération',
    STATE: 'État',
    SUBMISSION_DATE: 'Date de soumission'
  },
  LABEL: {
    ACCUMULATE: 'Accumuler',
    ACCUMULATED: 'Accumulée',
    ACTIVES: 'Actives',
    ALL: 'Toutes',
    BEGIN_DATE: 'Date de début',
    CANCEL: 'Annuler',
    CANCEL_ACCUMULATION: 'Annuler l\'accumulation',
    CANCEL_COUPON: 'Annuler le coupon',
    CANCEL_INVOICE: 'Annuler la facture',
    CLOSE: 'Fermer',
    CODE: 'Code',
    CONFIRM: 'Confirmer',
    CONFIRM_ACCUMULATE: 'Accumuler',
    CONFIRM_COUPON_CREATION: 'Générer coupon',
    CONFIRM_SUBMIT_INVOICE: 'Envoyer',
    COPY_COUPON_CODE: 'Copier code du coupon',
    COUPON: 'Coupon',
    COUPON_CODE: 'Code du coupon',
    CURRENT_PERIOD: 'Période actuelle',
    DATE: 'Date',
    DESCRIPTION: 'Description',
    END_DATE: 'Date de fin',
    FILTER: 'Filtre',
    GENERATE_COUPON: 'Générer coupon',
    GO_TO_DETAILS: 'Détails',
    INVOICE: 'Facture',
    MODEL: 'Modèle',
    MONEY: 'Argent',
    MONTH: 'Mois',
    NEW_INVOICE: 'Nouvelle facture',
    PAYMENT_METHOD: 'Mode de paiement',
    PENDING_COUNTERPARTS: 'Contreparties en attente',
    PENDING_COUNTERPARTS_MODAL_TITLE: 'Contreparties en attente',
    PENDING_VALUE: 'Montant en attente',
    PREVIOUS_PERIOD: 'Période précédente',
    REMUNERATION: 'Rémunération',
    SELECTED_PRODUCTS: 'Produits sélectionnés',
    STATE: 'État',
    SUBMIT_INVOICE_ATTACHMENT: 'Pièce jointe (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Commentaire',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Montant',
    WITHOUT_PRODUCTS: 'Sans produits sélectionnés',
    YEAR: 'Année'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION: 'Es-tu sûr(e) de vouloir annuler l\'accumulation ?',
    CANCEL_COUPON: 'Es-tu sûr(e) de vouloir annuler le coupon {value} ?',
    CANCEL_INVOICE:
      'Es-tu sûr(e) de vouloir annuler la soumission de la facture ?',
    CANT_GENERATE_COUPON: 'Tu ne peux pas générer ce coupon.',
    CANT_SUBMIT_REMUNERATION: 'Tu ne peux pas soumettre cette facture.',
    CONFIRM_SUBMIT_COUPON:
      'Tu vas générer un coupon de {couponValue}. Souhaites-tu continuer?',
    EMPTY_TITLE: 'Aucune donnée'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Rémunération accumulée',
    CANCEL_ACCUMULATION: 'Accumulation annulée',
    CANCEL_INVOICE: 'Facture annulée',
    COUPON_CANCELED: 'Coupon annulé',
    COUPON_COPIED: 'Coupon copié dans le presse-papiers',
    COUPON_GENERATED: 'Coupon créé avec le code {value}',
    INVOICE_SUBMITTED: 'Facture soumise',
    SUCCESS: 'Succès'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Rémunération accumulée',
    ATTACHMENT: 'Pièce jointe',
    CHALLENGE: 'Challenge',
    COUPON: 'Coupon',
    COUPON_CODE: 'Code du coupon',
    DECISION: 'Décision',
    MONTH: 'Mois',
    OBSERVATIONS: 'Observations',
    REMUNERATION: 'Rémunération',
    STATE: 'État',
    SUBMISSION_DATE: 'Date de soumission',
    SWIPE: 'Faire glisser vers la gauche pour voir plus de colonnes.',
    VIEW_CHALLENGE_DETAILS: 'Voir les détails du challenge'
  }
};
